import React, { useState } from 'react'
import GlassPanel from '../UI/GlassPanel'
import FormField from '../Forms/FormField'
import ArtistEditModal from '../ArtistEditModal'
import ArtistDisplay from './ArtistDisplay'
import ArtistForm from './ArtistForm'

const ArtistSection = ({ event, onArtistChange, onAddArtist, onRemoveArtist }) => {
  const [artistEditModalOpen, setArtistEditModalOpen] = useState(false)
  const [editingArtistIndex, setEditingArtistIndex] = useState(null)

  // Check if event is in the future
  const isFutureEvent = event.endDate && new Date(event.endDate) > new Date()

  const openArtistEditModal = (index) => {
    setEditingArtistIndex(index)
    setArtistEditModalOpen(true)
  }

  const handleArtistSave = (updatedArtist) => {
    if (editingArtistIndex !== null) {
      // Update all fields at once using the 'bulk' update feature
      onArtistChange(editingArtistIndex, 'bulk', {
        ...updatedArtist,
        confirmed: true // Ensure it stays confirmed
      })
    }
    setEditingArtistIndex(null)
  }

  return (
    <>
      <GlassPanel className="p-6 mb-8">
        <h2 className="text-xl font-semibold text-white mb-6">🎤 Artists & Lineup</h2>

        <div className="mb-6">
          <div className="flex items-center justify-between mb-4">
            <label className="block text-sm font-medium text-gray-200">
              Artist(s) seen ({event.artistsSeen.filter(a => a.confirmed).length})
            </label>
            <button
              type="button"
              onClick={onAddArtist}
              className="bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-4 rounded-lg transition-all duration-300"
            >
              ➕ Add Artist
            </button>
          </div>

          <ArtistDisplay
            artists={event.artistsSeen}
            onArtistChange={onArtistChange}
            onEdit={openArtistEditModal}
            onRemoveArtist={onRemoveArtist}
            isFutureEvent={isFutureEvent}
          />

          {event.artistsSeen.some(artist => !artist.confirmed) && (
            <div className="space-y-4">
              {event.artistsSeen.map((artist, index) => {
                if (artist.confirmed) return null
                return (
                  <ArtistForm
                    key={index}
                    artist={artist}
                    index={index}
                    onArtistChange={onArtistChange}
                    onRemove={onRemoveArtist}
                  />
                )
              })}
            </div>
          )}
        </div>

        <FormField
          label="General Lineup"
          name="lineup"
          value={event.lineup}
          onChange={() => {}} // This is handled by the parent
          placeholder="List the event lineup (will be populated from artists above)..."
          multiline
          rows={3}
        />
      </GlassPanel>

      <ArtistEditModal
        isOpen={artistEditModalOpen}
        onClose={() => {
          setArtistEditModalOpen(false)
          setEditingArtistIndex(null)
        }}
        onSave={handleArtistSave}
        artist={editingArtistIndex !== null ? event.artistsSeen[editingArtistIndex] : null}
        eventDates={event.additionalDates}
      />
    </>
  )
}

export default ArtistSection